import React, { memo } from "react";
import ReactTurnstile from "react-turnstile";
import { TurnstileProps } from "./Turnstile.types";
import "./Turnstile.scss";
import { useLanguage } from "../../i18n/hooks";

/**
 * Turnstile 人机验证组件
 * 基于 Cloudflare Turnstile
 */
const Turnstile: React.FC<TurnstileProps> = ({
  siteKey,
  onChange,
  className = "",
}) => {
  const { language } = useLanguage();

  return (
    <div className={`turnstile ${className}`}>
      <ReactTurnstile
        language={language}
        className="turnstile__widget"
        sitekey={siteKey}
        onVerify={token => {
          onChange?.(token);
        }}
      />
    </div>
  );
};

const MemoizedTurnstile = memo(Turnstile);
MemoizedTurnstile.displayName = "Turnstile";

export default MemoizedTurnstile;
